import { getLocateText, oddsKeyArray, locateKeys } from '../oddsKeyArray'
import QXC7 from './QXC7'
const initDesignatedKey = () => {
  const keyObj = {}

  locateKeys.forEach((supKey, index) => {
    for (let i = 0; i <= 9; i++) {
      keyObj[getLocateText(i, index + 1)] = {
        mainKey: 'designated',
        supKey,
        groupKey: getLocateText(i, index + 1)
      }
    }
  })

  return keyObj
}

const initTwoSide = () => {
  const mainKey = 'two_side'
  const dragonTigerKeys = ['DRAGON', 'TIGER', 'TIE']
  const keyObj = {}
  let groupKey = ''

  for (const oddsKey of dragonTigerKeys) {
    groupKey = `1:5:${oddsKey}`
    keyObj[groupKey] = {
      mainKey,
      supKey: 'dragon_tiger',
      groupKey
    }
  }
  for (const oddsKey of oddsKeyArray) {
    groupKey = `ALL:SUM:${oddsKey}`
    keyObj[groupKey] = {
      mainKey,
      supKey: 'sum',
      groupKey
    }

    locateKeys.forEach((supKey, index) => {
      groupKey = `${index + 1}:${oddsKey}`
      keyObj[groupKey] = {
        mainKey,
        supKey,
        groupKey
      }
    })
  }

  return keyObj
}

const initGroupThree = () => {
  const mainKey = 'front_mid_back'
  const oddsKeyArray = ['TRIPLE', 'STRAIGHT', 'PAIR', 'HALFSTRAIGHT', 'MISCSIX']
  const keyObj = {}
  let str = ''

  for (let i = 1; i <= 3; i++) {
    switch (i) {
      case 1:
        str = 'first'
        break
      case 2:
        str = 'middle'
        break
      case 3:
        str = 'last'
        break
    }

    const mainAndSup = {
      mainKey,
      supKey: `${str}_three`
    }

    for (const oddsKey of oddsKeyArray) {
      const groupKey = `${oddsKey}:RANGE:${i}:${i + 1}:${i + 2}`
      keyObj[groupKey] = {
        ...mainAndSup,
        groupKey
      }
    }
  }

  return keyObj
}

export default {
  ...initDesignatedKey(),
  ...initTwoSide(),
  ...initGroupThree(),
  ...QXC7
}
